export default __webpack_public_path__ + "static/media/AI-Comms-2x.7740418b.png";